import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

export function getHotelOfferEncryptedMargin(offer?: App.Offer, packageView?: OfferPackageOptionView) {
  if (packageView?.package?.mx || packageView?.package?.roomRate?.mx) return packageView?.package?.mx ?? packageView?.package?.roomRate?.mx
  if (!offer) return undefined

  if (offer.lowestPricePackage?.mx || offer.lowestPricePackage?.roomRate?.mx) return offer.lowestPricePackage?.mx ?? offer.lowestPricePackage?.roomRate?.mx

  return undefined
}
